/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { nullReducer, payloadReducer } from '@zcode/reducers'
import type { ShortTermPoliciesState } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { ERROR_FETCHING_SHORT_TERM_POLICIES, RECEIVE_SHORT_TERM_POLICIES } from '../constants/index'
import type { ActionTypes } from '../types'
import { metaReducer } from './meta'

export const shortTermPolicies = combineReducers<ShortTermPoliciesState, ActionTypes>({
  data: handleActions<ShortTermPoliciesState['data'], ActionTypes>(
    {
      [RECEIVE_SHORT_TERM_POLICIES]: payloadReducer,
      [ERROR_FETCHING_SHORT_TERM_POLICIES]: nullReducer,
    },
    null
  ),
  meta: metaReducer,
})
